import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { ResponseSuccess } from '@core/models/response-success.model';

@Injectable({
    providedIn: 'root'
})
export class CuCustomerLinkService extends ApiService {

    types(params: any = {}): Observable<ResponseSuccess> {
        return super.get('/cu-customer-links/types', params);
    }
}
